import Card from "../../../../components/UI/Card";
import { useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import Button from "../../../../components/UI/Button";
import Input from "../../../../components/UI/form/Input";
import SelectAddressdList from "./SelectAddressdList";
import {checkFeatureAvailability} from "../../../../util/helper";

const BillingAddress = ({setValue, register, errors, getValues}) => {
  const {orderForm} = useSelector(state => state.orders)
  const [customer, setCustomer] = useState(null)
  const [openAddressModal, setAddressModal] = useState(false)
  const [editAddress, setEdit] = useState(false)
  const params = useParams()

  useEffect(()=>{
    if(customer === null) {
      setCustomer(orderForm.customer)
    }
  }, [orderForm])

  useEffect(()=>{
    if(customer) {
      if(customer.address.length) {
        if(!params.id) {
          selectedAddress(customer.address[0]);
        }
      }
    }
  }, [customer])

  const addressModalHandle = () => {
    setAddressModal(true)
  }

  const editBtnClickHandler = () => {
    setEdit(!editAddress)
  }

  const selectedAddress = (address) => {
    setValue('billing_address_id', address.id)
    setValue('billing_name', address.name)
    setValue('billing_mobile', address.phone)
    setValue('billing_address', address.address)
    setValue('billing_city', address.city)
    setValue('billing_postal_code', address.postal_code)
    setValue('billing_country', address.country)
  }

  const billingFields = ['billing_mobile', 'billing_name', 'billing_address', 'billing_city', 'billing_postal_code', 'billing_country'];

  const newErrors = Object.keys(errors).map((key) =>  key);

  useEffect(()=>{
    if(newErrors.some(element => billingFields.includes(element))){
      setEdit(true)
    }
  }, [newErrors])

  return (
    <>
      <Card>
        <h1 className="common_sub_title d_flex_btwn mt_0 mb_5">
          <span> Billing Address</span>
          {checkFeatureAvailability(orderForm, 'default', params) &&
          <span className="fw_regular font_15p d_flex_center">
            <img className="width_15p mr_10 cursor_pointer" onClick={editBtnClickHandler} src="/assets/media/images/edit.png" alt=""/>
            {(customer && customer.address.length) ? (
              <span className={'cursor_pointer text_underline'}  onClick={addressModalHandle} >Change Address</span>
              ) : ''
            }
        </span>}
        </h1>
        {!editAddress &&
          <p className="mb_5">
            {orderForm.billing_address } {orderForm.billing_city && `, ${orderForm.billing_city}`}
            <br/> {orderForm.billing_postal_code }, {orderForm.billing_country}</p>
        }
        <div className={`accordion_wrap ${editAddress ? 'd_block' : 'd_none'}`}>
          <div className="row">
            <div className="col_6">
              <Input label="Name"
                     inline={true}
                     name="billing_name"
                     errors={errors}
                     validationRules={{required: true, type: 'string'}}
                     register={register}/>
            </div>
            <div className="col_6">
              <Input label="Address"
                     inline={true}
                     name="billing_address"
                     errors={errors}
                     validationRules={{required: true, type: 'string'}}
                     register={register}/>
            </div>
            <div className="col_6">
              <Input label="Mobile No."
                     inline={true}
                     name="billing_mobile"
                     errors={errors}
                     validationRules={{required: true, type: 'string'}}
                     register={register}/>
            </div>
            <div className="col_6">
              <Input label="City"
                     inline={true}
                     name="billing_city"
                     errors={errors}
                     validationRules={{required: true, type: 'string'}}
                     register={register}/>
            </div>
            <div className="col_6">
              <Input label="Post Code"
                     inline={true}
                     name="billing_postal_code"
                     errors={errors}
                     validationRules={{required: true, type: 'string'}}
                     register={register}/>
            </div>
            <div className="col_6">
              <Input label="Country"
                     inline={true}
                     name="billing_country"
                     errors={errors}
                     validationRules={{required: true, type: 'string'}}
                     register={register}/>
            </div>
            {(customer && customer.address.length) ? (
              <div className="col_12">
                <div className="width_full d_flex_end mt_20">
                  <Button text={"Ok"} onClickHandler={editBtnClickHandler} variant={'btn_black'} />
                </div>
              </div>
            ) : ''}
          </div>
        </div>
      </Card>

      <SelectAddressdList openAddressModal={openAddressModal} setAddressModal={setAddressModal} setValue={setValue} selectedAddressType={'Billing'} />
    </>
  );
}

export default BillingAddress;